"use client";

import { useEffect } from "react";
import { useCookieSettings } from "hooks/cookies/useCookieSettings";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";

// Add type declaration for window.dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Component to handle Google Consent Mode v2 updates
 * Updates consent state when user interacts with cookie consent banner
 */
export const GoogleConsentMode = () => {
  const { cookieSettings } = useCookieSettings();
  const { isWithinGDPR } = useCountryStateCookies();

  // Update Google's consent state when cookieSettings change
  useEffect(() => {
    // Only update if the user has made a choice (dismissed banner)
    if (cookieSettings.hasDismissed) {
      // Map our cookie settings to Google's consent categories
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(function () {
        // @ts-ignore - gtag is defined by GTM
        (window as any).gtag?.("consent", "update", {
          ad_storage: cookieSettings.allowAnalytics ? "granted" : "denied",
          analytics_storage: cookieSettings.allowAnalytics
            ? "granted"
            : "denied",
          functionality_storage: "granted", // We assume functionality cookies are always allowed
          personalization_storage: cookieSettings.allowAnalytics
            ? "granted"
            : "denied",
          ad_user_data:
            cookieSettings.allowAnalytics && !cookieSettings.enableOptOutCcpa
              ? "granted"
              : "denied",
          ad_personalization:
            cookieSettings.allowAnalytics && !cookieSettings.enableOptOutCcpa
              ? "granted"
              : "denied"
        });
      });

      // Push a consent_updated event to dataLayer for GTM triggers
      window.dataLayer.push({
        event: "consent_updated",
        consent_settings: {
          analytics: cookieSettings.allowAnalytics,
          ccpaOptOut: cookieSettings.enableOptOutCcpa,
          region: isWithinGDPR ? "GDPR" : "non-GDPR"
        }
      });
    }
  }, [
    cookieSettings.hasDismissed,
    cookieSettings.allowAnalytics,
    cookieSettings.enableOptOutCcpa,
    isWithinGDPR
  ]);

  // This component doesn't render anything
  return null;
};

export default GoogleConsentMode;
